// import PeMoreInfo from "../../components/PeMoreInfo";
import PeSingleChoice from "../../components/PeSingleChoice";
import AddressAutoComplete from '../../components/PeAddressFields';
import PeSubsidy from "../../components/PeSubsidy";

const installOpt = {
    type_phase: [
        { label: "Single Phase", value: "e05a85fb-8a54-03ff-1f3e-6114a54151b7" },
        { label: "Three Phase", value: "d6095966-02f1-e8ac-42c9-619746789c89" },
    ],
    yes_no: [{
        label: "Yes",
        value: "yes"
    }, {
        label: "No",
        value: "no"
    }],
};

export const installationStepField = [
    {
        name: "full_address",
        component: AddressAutoComplete,
        siblingField: ["zip", "locality", "state", "country_iso2", "lat", "lon"],
        props: {
          label: "Your Install Address",
          toolTip: "Enter your install address so we can determine any applicable Federal Government and State Government upfront discounts as well as confirm your water quality",
          required: true,
        },
    }, 
    {
        name: "choice_type_install",
        dependOn: "full_address",
        component: PeSingleChoice,
        props: {
            label: "Single Phase or Three Phase?",
            toolTip: "Do you have an existing HWS that needs replacing with a Sanden or is it a New Build/Renovation where there is no hot water system present?",
            required: true,
            options: installOpt.type_phase,
            // source: 'pricingOptions',
        },
    },
    {
        name: "exist_hws_gt_3yr",
        component: PeSingleChoice,
        dependOn: "{\"state\": \"VIC\",\"choice_type_install\":\"\"}",
        props: {
            label: "Solar Vic Solar Hot Water Rebate - If you haven't accessed Solar Vic Solar PV or Battery Storage Rebates, Your Existing HWS >3 years old, Household Income <$180k p.a., Asset Value $3m - Would you like to apply for the Solar Vic Solar Hot Water Rebate?",
            required: true,
            options: installOpt.yes_no,
            sm: 2,
        },
        condition: [{
            value: '',
            fieldChild: [{
                name: "subsidies",
                dependOn: "exist_hws_gt_3yr",
                component: PeSubsidy,
                props: {
                    label: "Applicable Subsidies",
                    toolTip: "",
                },
            }]
        }]
    },
]